/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 113
// module chunks = 0